import { writable } from 'svelte/store';
import { userAPIService } from './api/user.api.service';
class UserService {
    constructor() {
        this.user = writable();
    }
    async setCurrentAuthenticatedUser() {
        const user = await userAPIService.me();
        if ('error' in user) {
            return;
        }
        this.user.set(user);
    }
}
;
export const userService = new UserService;
